function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M295.09,420.82a5,5,0,0,0-3.08,1,2.71,2.71,0,0,0,0,4.5,5,5,0,0,0,3.08,1h.38a10.32,10.32,0,0,0,0-6.5Z",
  transform: "translate(-288.7 -415.72)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M296.64,415.72a7.94,7.94,0,1,0,7.94,7.94A7.94,7.94,0,0,0,296.64,415.72ZM296,427.88a.33.33,0,0,1-.26.24c-.2,0-.41,0-.61,0a5.43,5.43,0,0,1-3.4-1.13,4.22,4.22,0,0,1-1.08-1.28,3.49,3.49,0,0,1,0-3.32,4.22,4.22,0,0,1,1.08-1.28,5.43,5.43,0,0,1,3.4-1.13c.2,0,.41,0,.61,0a.33.33,0,0,1,.26.24,11.6,11.6,0,0,1,.65,3.78A11.32,11.32,0,0,1,296,427.88Zm6.39-5.49c0,.22-.09.39-.21.39h-4.73c-.12,0-.22-.17-.22-.39s.1-.38.22-.38h4.73C302.26,422,302.35,422.18,302.35,422.39Zm-5.14-2h4.73c.12,0,.21.17.21.38s-.09.39-.21.39h-4.73c-.12,0-.22-.17-.22-.39S297.09,420.35,297.21,420.35Zm4.73,7.48h-4.73c-.12,0-.22-.17-.22-.39s.1-.38.22-.38h4.73c.12,0,.21.17.21.38S302.06,427.83,301.94,427.83Zm.2-1.66h-4.73c-.12,0-.22-.17-.22-.39s.1-.38.22-.38h4.73c.12,0,.21.17.21.38S302.26,426.17,302.14,426.17Zm.08-1.69h-4.73c-.12,0-.21-.17-.21-.39h0c0-.21.09-.38.21-.38h4.73c.12,0,.21.17.21.38h0C302.43,424.31,302.34,424.48,302.22,424.48Z",
  transform: "translate(-288.7 -415.72)"
});

function SvgIconFlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.88 15.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlash);
export default __webpack_public_path__ + "static/media/icon-flash.5066b16b.svg";
export { ForwardRef as ReactComponent };